export default "__VITE_ASSET__Cj2EvJMG__"